
//
// Import Controller Library
//

var Controllers = {
  'admin':        require('./admin'),
  'modal':        require('./modal'),
  'debug':        require('./debug'),
  'campaign':     require('./campaign'),
  'payment':      require('./payment'),
  'personalise':  require('./personalise'),
  'vouchers':     require('./vouchers'),
  'live-search':  require('./live-search'),
  'lock-screen':  require('./lock-screen'),
  'cart-sync':    require('./cart-summary-sync'),
};


//
// Controller Detection and Initialisation
//

module.exports = {
  initAllWithin: function initControllers (subdom) {
    QSA('[data-controller]').forEach(function (el) {
      var types = el.dataset.controller.split(' ');

      types.forEach(function (type) {
        if (Controllers[type]) {
          Controllers[type]($(el), findInside(el));
        } else if (type !== '') {
          console.warn('No such controller:', type);
        }
      });
    });
  }
};

